module.exports = __webpack_public_path__ + "static/img/CameronMurray.590723c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CameronMurray.jpg
// module id = lTeV
// module chunks = 0